import { useContext } from "react";
import { AppContext, AppContextData } from "./appData";
import { SessionKey } from "../utils/app-config";
import { IUserModel } from "../typings/models/UserModel";
import { IApplicationPayment } from "../typings/interfaces/Payment/ApplicationPayment";
export const useContextService = () => {
  const appContext = useContext(AppContext);

  const putContextUser = async (value: IUserModel): Promise<void> => {
    await resetContextUser();
    appContext.user = value;
    setContextValueToStorage();
  };

  const putContextToken = async (value: string): Promise<void> => {
    await resetContextToken();
    appContext.token = value;
    setContextValueToStorage();
  };

  const putContextApplicationPayment = async (value: IApplicationPayment): Promise<void> => {
    await resetContextApplicationPayment();
    appContext.payment = value;
  };

  const setContextValueToStorage = () => {
    localStorage.setItem(SessionKey.AppData, JSON.stringify(appContext));
  };

  const getContextValueFromStorage = (initialValue: AppContextData) => {
    const value = localStorage.getItem(SessionKey.AppData);
    return value ? (JSON.parse(value) as AppContextData) : initialValue;
  };

  const resetContextUser = async () => {
    appContext.user = {} as IUserModel;
  };

  const resetContextToken = async () => {
    appContext.token = '' as string;
  };

  const resetContextApplicationPayment = async () => {
    appContext.payment = {} as IApplicationPayment;
  };

  const clearAppStorage = () => {
    localStorage.clear();
  };

  const resetAppContext = async () => {
    appContext.user = {} as IUserModel;
    clearAppStorage();
  };
  return {
    putContextUser: putContextUser,
    resetAppContext: resetAppContext,
    getContextValueFromStorage,
    setContextValueToStorage,
    putContextApplicationPayment,
    resetContextApplicationPayment,
    putContextToken
  };
};
